export default __webpack_public_path__ + "0dd6dc4738add061d06dea811974415a.png";